import Lottie from 'lottie-react';
import { HeadTitle, Popup } from 'oui';
import { useMtgLoading } from '../../../application/bloc/useMtgLoading';
import loading from '../../../assets/lottie/loading.json';

export const MtgLoading = () => {
  const { titleContent, popup } = useMtgLoading();
  return (
    <>
      <HeadTitle textTitle={titleContent} />

      <Lottie animationData={loading} />

      <Popup
        title={popup.message}
        description={popup.description}
        isPopupOpen={popup.open}
        confirmBtn={{ text: popup.confirmText, onClick: popup.onClickConfirm }}
        cancelBtn={{ text: popup.cancelText, onClick: popup.onClickCancel }}
      />
    </>
  );
};
